import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ApproverCard.module.scss';
import ButtonComponent from '../../buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../buttons/types';
import { distanceDateFormat } from '../../../../utils/helpers';

export function ApproverCard({ approverRowData, labelText, setCardToggle }) {
  const { t } = useTranslation();

  const clientName = approverRowData.Timesheet
    ? approverRowData.Timesheet.ClientName
    : approverRowData.Expense.ClientName;

  const timesheetDates = approverRowData.Timesheet?.TimesheetDetails[0].TimesheetHoursByDates;
  const firstDate = timesheetDates?.length && timesheetDates[0].Day;
  const lastDate = timesheetDates?.length && timesheetDates.at(-1).Day;

  return (
    <Box className={styles.boxSize}>
      <Box>
        <Grid className={styles.closeIcon} item onClick={() => setCardToggle(true)}>
          <CloseIcon />
        </Grid>
        <Grid container className={styles.maxHeight}>
          <Grid item xs className={styles.approverLabel}>
            <div>
              <h4>{labelText}</h4>
            </div>
          </Grid>
          <Grid className={styles.approverTimeStamp} item>
            <p className={styles.timeStamp}>{distanceDateFormat(approverRowData?.CreatedDate)}</p>
          </Grid>
        </Grid>

        <Grid container className={styles.maxHeight} sx={{ marginTop: '-10px' }}>
          <Grid className={styles.responsiveLabel}>
            <p>{t('dashboard.cards.client')}</p>
          </Grid>
          <Grid className={styles.responsiveLabelName}>
            <p>{clientName}</p>
          </Grid>
        </Grid>

        <Grid container className={styles.maxHeight}>
          <Grid className={styles.responsiveLabel}>
            <p>{t('dashboard.cards.approver')}</p>
          </Grid>
          <Grid className={styles.responsiveLabelName}>
            <p>
              {approverRowData?.FirstName} {approverRowData?.LastName}
            </p>
          </Grid>
        </Grid>

        <Grid container className={styles.maxHeight}>
          <Grid className={styles.responsiveLabel}>
            <p>{approverRowData.Timesheet ? t('dashboard.cards.timesheet') : t('dashboard.cards.claim')}</p>
          </Grid>
          <Grid className={styles.responsiveLabelName}>
            <p>
              {approverRowData.Timesheet
                ? `${dayjs(firstDate).format('DD MMM')} - ${dayjs(lastDate).format('DD MMM YYYY')}`
                : approverRowData.Expense.ClaimDescription}
            </p>
          </Grid>
        </Grid>

        <Grid className={styles.buttonStyle}>
          <Link
            to={
              approverRowData.Timesheet
                ? `/dashboard/timesheet/${approverRowData?.Timesheet.Id}`
                : `/dashboard/expense/${approverRowData?.Expense.Id}`
            }
            onClick={(e) => e.stopPropagation()}
          >
            <ButtonComponent
              className={styles.buttonComponent}
              variant={buttonVariants.ROUNDED}
              text={approverRowData.Timesheet ? t('dashboard.cards.seemytimesheet') : t('dashboard.cards.seemyclaim')}
            />
          </Link>
        </Grid>
      </Box>
    </Box>
  );
}
